'use client';
import LoginTemplate from '@/components/Login/LoginTemplate';
import ForgotPassword from '@/views/Login/components/ForgotPassword/ForgotPassword';

export default function RegistrarSenha() {
  return (
    <LoginTemplate>
      <ForgotPassword />
    </LoginTemplate>
  );
}
